import axios from 'axios'
import { API_BASE_URL, API_EXTERNAL_URL } from '../constants'


export const ping = ({ url = API_BASE_URL, timeout=5000, isOnlineCallback, isOfflineCallback }) => {
  return new Promise(resolve => {
    const isOnline = () => {
      isOnlineCallback()
      resolve(true);
    }
    const isOffline = () => {
      isOfflineCallback()
      resolve(false);
    }

    const xhr = new XMLHttpRequest();

    xhr.onerror = isOnline;
    xhr.ontimeout = isOffline;
    xhr.onreadystatechange = () => {
      if (xhr.readyState === xhr.HEADERS_RECEIVED) {
        if (xhr.status) {
          isOnline();
        } else {
          isOffline();
        }
      }
    };

    xhr.open("GET", url);
    xhr.timeout = timeout;
    xhr.send();
  });
}


const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 180000 // 3 minutes timeout
})

// Add request interceptor for better error handling
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      console.warn('Request timeout - this might be due to slow external service calls');
    }
    if (error.message.includes('ERR_NETWORK_CHANGED')) {
      console.warn('Network changed during request - retrying might help');
    }
    return Promise.reject(error);
  }
)


export const makeCall = (method, url, data = {}, headers = {}, params = {}, extra = {}) => {
  return client.request({
    method,
    data,
    url,
    headers,
    params,
    ...extra
  })
}


const externalClient = axios.create({
  baseURL: API_EXTERNAL_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000 // 30 seconds timeout for external API
})


export const makeExternalCall = (method, url, data = {}, headers = {}, params = {}, extra = {}) => {
  return externalClient.request({
    method,
    data,
    url,
    headers,
    params,
    ...extra
  })
}
